const merge = require('deepmerge');
import { config } from '../shared/config';

export const remote = {
  fetch(url, opts) {
    // Prepend API root if not present in requests
    if (!url.includes(config.apiUrl)) {
      url = config.apiUrl + '/' + normalizeUrl(url);
    }

    return fetch(url, _apiRequestOptions(opts))
      .then(_parseJSONAndStatus);
  },

  del(url, opts) {
    return remote.fetch(url, merge(opts, {
      method: 'DELETE',
    }));
  },

  get(url, opts) {
    return remote.fetch(url, opts);
  },

  patch(url, data, opts) {
    return remote.fetch(url, merge({
      body: JSON.stringify(data),
      method: 'PATCH',
    }, opts));
  },

  post(url, data, opts) {
    return remote.fetch(url, merge(opts, {
      body: JSON.stringify(data),
      method: 'POST',
    }));
  },

  put(url, data, opts) {
    return remote.fetch(url, merge(opts, {
      body: JSON.stringify(data),
      method: 'PUT',
    }));
  },
};

function _apiRequestOptions(opts) {
  let defaults = {
    method: 'get',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'text/plain',
    },
  };

  return merge(defaults, opts);
}

function _parseJSONAndStatus(res) {
  let httpStatus = res.status;
  let contentType = res.headers.get('content-type');

  // Just return response for non-JSON requests
  if (!contentType || !contentType.includes('application/json')) {
    return res;
  }

  return res.text()
    .then(responseBody => {
      let json = responseBody;

      if (contentType && contentType.includes('json') && httpStatus !== 204 && responseBody.length > 0) {
        try {
          json = JSON.parse(responseBody);
        } catch(e) {
          return Promise.reject(new TypeError(`Invalid JSON response body: '${responseBody}' at ${this._request.url} reason: '${e.message}'`));
        }
      }

      if (httpStatus >= 200 && httpStatus < 300) {
        return json;
      } else if (httpStatus === 401) {
        // Redirect to login
        location.href = '/login';
        return;
      } else {
        let errorMessage = json.message || json.details || res.statusText;

        if (json.errors && json.errors[0]) {
          errorMessage = json.errors[0].title || json.errors[0].detail;
        }

        let err = new Error(httpStatus + ': ' + errorMessage);

        console.error(err);

        return Promise.reject(err);
      }
    });
}

function normalizeUrl(url) {
  if (url === '/' || !url) { return '/'; }

  if (url.startsWith('/')) {
    url = url.substr(1);
  }

  if (url.endsWith('/')) {
    url = url.substring(0, url.length - 1);
  }

  return url;
}

